/* eslint-disable no-param-reassign */
import React, { useEffect, useState } from 'react';
import { Typography, IconButton, Box, Divider } from '@mui/material';
import { ChevronRight, ExpandMore } from '@mui/icons-material';

import xml2js from 'xml2js';
import MapMarkerIcon from '../../../../assets/icons/map-marker-icon';
import theme from '../../../../globals/theme';
import TreeDataView from '../../../tree-data-view';
import { headCells } from './head-cells';
import { createJSONTree } from '../calls';

const GPSLatitude = 'GPSLatitude';
const GPSLongitude = 'GPSLongitude';
const fileTypeId = 'FileTypeID'
const googleMapsExternal = 'https://www.google.com/maps/search/?api=1&query=';

const ParsedData = ({
  parsedMessage,
  updateHeight,
}: {
  parsedMessage: string;
  updateHeight: Function;
}) => {
  const hygienicXml = parsedMessage.replace(/\\/g, '').replace(`"`, '').replace(`>"`, '>');
  const parser = new DOMParser();
  const xmlDocument: XMLDocument = parser.parseFromString(hygienicXml, 'text/xml');
  const latitude: any = xmlDocument.querySelectorAll(GPSLatitude);
  const longitude: any = xmlDocument.querySelectorAll(GPSLongitude);
  const fileType: any = xmlDocument.querySelectorAll(fileTypeId)
  const [parsedJson, setParsedJson] = useState<any>();

  useEffect(() => {
    xml2js.parseString(
      hygienicXml,
      {
        explicitChildren: true,
        childkey: 'children',
        charkey: 'value',
        explicitCharkey: true,
        attrkey: 'attributes',
        explicitArray: false,
      },
      (error, result: any) => {
        if (result) {
          if(fileType && fileType.length > 0)
            setParsedJson(createJSONTree(result, fileType[0].textContent));
          else
            setParsedJson(createJSONTree(result, "0"));
        }
      },
    );
  }, [parsedMessage, hygienicXml]);

  useEffect(() => {
    updateHeight();
  }, [parsedJson]);

  const [expanded, setExpanded] = useState(true);
  const toggleExpanded = () => {
    updateHeight();
    setExpanded(!expanded);
  };

  return parsedJson ? (
    <Box pb={1}>
      <Divider />
      <Box display="flex" alignItems="center" pt={1}>
        <Typography variant="h6">Parsed Data</Typography>
        {latitude.length > 0 && longitude.length > 0 ? (
          <IconButton
            onClick={() =>
              window.open(
                `${googleMapsExternal}${latitude[0].textContent},${longitude[0].textContent}`,
              )
            }
            aria-label="expand"
            style={{ width: '1rem', height: '1rem', marginLeft: '0.5rem' }}
            size="large"
          >
            <MapMarkerIcon strokeWidth="3" stroke={theme.palette.grey[500]} height="1rem" />
          </IconButton>
        ) : null}
        <IconButton
          onClick={toggleExpanded}
          aria-label="expand"
          style={{ width: '1rem', height: '1rem' }}
          size="large"
        >
          {expanded ? <ExpandMore /> : <ChevronRight />}
        </IconButton>
      </Box>
      {expanded && (
        <TreeDataView
          data={parsedJson}
          headCells={headCells}
          maxHeight={300}
          updateHeight={updateHeight}
        />
      )}
    </Box>
  ) : null;
};

export default ParsedData;
